import React from 'react';
import {BrowserRouter, Route, Switch, Link, HashRouter} from 'react-router-dom'
import BuildYourTeamPage from './components/build-your-team';
import Homepage from './components/homepage';
import API from './api';

import Homepage2 from './components/homepage2';

import BuildThankYou from './components/build-your-team-thank-you';
import Page from './components/page';
import AboutUsPage from './components/about_page';
import ClientsPage from './components/clients_page';
import TeamPage from './components/team';
import { FrontEndPage, BackEndPage, UiUxPage, MicrosoftPage, MobilePage, DatabasePage, DevOpsPage, TeamContent } from "./api/PageContent";
// History
import createHistory from 'history/createBrowserHistory'
const history = createHistory();
const location = history.location;

localStorage.setItem('isFirst', "false");

function hashLinkScroll() {
    window.scrollTo(0, 0);
    API.trackingPage();
    return null;
}

const router = (
    <BrowserRouter history={history}>  
        <main>
            <Route component={hashLinkScroll} />
            <Switch>
                <Route exact path='/1' component={Homepage} />
                <Route exact path='/' render={(props) => (
                    <Homepage2 {...props}/>
                )}/>
                <Route exact path='/build-your-team' component={BuildYourTeamPage}/>
                <Route exact path='/build-your-team/:page' component={BuildThankYou} />
                <Route path='/services/front-end' render={(props) => (
                    <Page {...props} data={FrontEndPage} />
                )} />
                <Route path='/services/back-end' render={(props) => (
                    <Page {...props} data={BackEndPage} />
                )} />
                <Route path='/services/mobile' render={(props) => (
                    <Page {...props} data={MobilePage} />
                )} />
                <Route path='/services/microsoft' render={(props) => (
                    <Page {...props} data={MicrosoftPage} />
                )} />
                <Route path='/services/database' render={(props) => (
                    <Page {...props} data={DatabasePage} />
                )} />
                <Route path='/services/devops' render={(props) => (
                    <Page {...props} data={DevOpsPage} />
                )} />
                <Route path='/services/ui-ux' render={(props) => (
                    <Page {...props} data={UiUxPage} />
                )} />
                <Route path='/about-us' render={(props) => (
                    <AboutUsPage {...props} data={AboutUsPage}/>
                )} />
                <Route path='/clients' render={(props) => (
                    <ClientsPage {...props} data={ClientsPage}/>
                )} />
                <Route path='/team' render={(props) => (
                    <TeamPage {...props} data={TeamContent}/>
                )} />
        </Switch>
    </main>
</BrowserRouter>
);

export default router;



// WEBPACK FOOTER //
// ./src/router.js